const PALETTE: readonly string[] = [
  '#005f69',
  '#408a8e',
  '#52b1b6',
  '#bef03c',
  '#f3b13b',
  '#c94a4a',
  '#7bcfd3',
  '#87aa2b',
  '#326b6e',
];

export function customerColor(name: string): string {
  if (!name) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}

export function customerInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '??';
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
